import type ApplicationInstance from '@ember/application/instance';

export function initialize(appInstance: ApplicationInstance): void {
  void (async () => {
    try {
      const { Capacitor } = await import('@capacitor/core');
      if (!Capacitor.isNativePlatform()) return;

      const { App } = await import('@capacitor/app');
      const router = appInstance.lookup('service:router') as {
        transitionTo: (path: string) => void;
      };

      App.addListener('appUrlOpen', ({ url }) => {
        try {
          const parsed = new URL(url);
          const path = parsed.pathname + parsed.search;
          // Clear any pending share navigation — the deep link takes precedence.
          localStorage.removeItem('favoris:open-after-share');
          router.transitionTo(path);
        } catch {
          // Invalid URL — ignore
        }
      }).catch(() => {
        // Swallow listener registration errors
      });

      // Fallback: when the user manually reopens MainActivity after a share
      // (e.g. dev build where the custom scheme intent didn't auto-navigate),
      // complete the navigation from the stored path.
      App.addListener('appStateChange', (state) => {
        if (!state.isActive) return;
        const path = localStorage.getItem('favoris:open-after-share');
        if (!path) return;
        localStorage.removeItem('favoris:open-after-share');
        try {
          router.transitionTo(path);
        } catch {
          // Router not ready — ignore
        }
      }).catch(() => {
        // Swallow listener registration errors
      });
    } catch {
      // Not a Capacitor environment
    }
  })();
}

export default { initialize };
